/**
 * The words for an identity document's type, as every console screen says them.
 *
 * The type comes from the identity PROVIDER's vocabulary rather than ours, so Identity checks
 * (where the document is reviewed) and Player funds → Payout accounts (where its name is compared
 * with a payout account's) read it from this one map: one document is never "Driver's licence" on
 * one screen and "drivers license" on the other.
 *
 * Unknown values pass through with the underscores opened out instead of being mapped to a guess —
 * a provider that adds a type must not have it silently renamed to something this list happens to
 * contain.
 */
export const DOCUMENT_WORDS: Readonly<Record<string, string>> = {
  drivers_license: "Driver's licence",
  passport: 'Passport',
  national_id: 'PhilSys national ID',
  umid: 'UMID',
  postal_id: 'Postal ID',
  others: 'Something else',
};

export function documentWords(raw: string | null): string | null {
  if (raw === null) return null;
  return DOCUMENT_WORDS[raw] ?? raw.replace(/_/g, ' ');
}
